import { DELETE_ACCOUNT_URL, RESEND_OTP_URL, USER_FORGOT_PASSWORD_URL, USER_FORGOT_PASSWORD_VIEW_URL, USER_LOGIN_PHONE_URL, USER_LOGIN_URL, USER_LOGOUT_URL, USER_REGISTER_URL, VERIFY_MOBILE_SIGN_UP, VERIFY_OTP_URL } from "../../api";
import axiosInstance from '../../axiosInstance';


export const userLogin = (props) => onResponse => {
    try {
        axiosInstance.post(USER_LOGIN_URL, props.formData)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const userLogout = (formData) => onResponse => {
    try {
        axiosInstance.post(USER_LOGOUT_URL, formData)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const userLoginPhone = (phone, type_of_user, notification_token) => onResponse => {
    try {
        axiosInstance.post(USER_LOGIN_PHONE_URL, { phone, type_of_user, notification_token: notification_token ?? "" })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });
    } catch (error) {
        onResponse(error);
    }
};
export const userResendOtp = (phone, type_of_user) => onResponse => {
    try {
        axiosInstance.post(RESEND_OTP_URL, { phone, type_of_user })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const userRegister = (props) => onResponse => {
    try {
        axiosInstance.post(USER_REGISTER_URL, props.formData)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const verifyOtp = (otp, notification_token) => onResponse => {
    try {
        axiosInstance.post(VERIFY_OTP_URL, { otp, notification_token: notification_token ?? "" })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const userForgotPassword = (phone, type_of_user, password, confirm_password) => onResponse => {
    try {
        axiosInstance.post(USER_FORGOT_PASSWORD_URL, { phone, type_of_user, password, confirm_password })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const userForgotPasswordView = (phone, type_of_user, password, confirm_password) => onResponse => {
    try {
        axiosInstance.put(USER_FORGOT_PASSWORD_VIEW_URL, { phone, type_of_user, password, confirm_password })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const verifyMobileSignup = (phone, type_of_user) => onResponse => {
    try {
        axiosInstance.put(VERIFY_MOBILE_SIGN_UP, { phone, type_of_user })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const deleteAccountUser = () => onResponse => {
    try {
        axiosInstance.delete(DELETE_ACCOUNT_URL, {})
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
